// client/src/coms/interactions/InteractionMenu.js
// The "Create interaction" list shared by the channel context menu (desktop right-click, mobile long-press)
// and the composer's interaction button. Only types the member may create in that channel are listed (the
// server checks again); "Browse interactions" opens the channel's filterable list.
import React from 'react';
import { TYPE_META, TYPE_ORDER, openInteractionBrowser, openInteractionCreator, useInteractionCapabilities } from './interactionStore';
import './interactions.css';

export default function InteractionMenu({ serverKey, kind, channelId, channelName, onPicked, showBrowse = true }) {
  const caps = useInteractionCapabilities(kind, channelId);
  const k = kind === 'voice' ? 'voice' : 'text';
  if (!caps) return <div className="vxi-muted" style={{ padding: '6px 10px' }}>Loading…</div>;
  const types = TYPE_ORDER.filter((t) => caps.create && caps.create[t]);
  const base = { serverKey, kind: k, channelId: Number(channelId), channelName };
  return (
    <div className="vxi-menu" role="menu" aria-label="Create interaction">
      {types.length ? (
        types.map((t) => (
          <button
            key={t}
            type="button"
            role="menuitem"
            className="vxi-menu-item"
            data-testid={`interaction-menu-${t}`}
            onClick={() => {
              if (onPicked) onPicked();
              openInteractionCreator({ ...base, type: t });
            }}
          >
            <span className="vxi-menu-icon" aria-hidden="true">{TYPE_META[t].icon}</span>
            <span>
              {TYPE_META[t].label}
              <small>{TYPE_META[t].hint}</small>
            </span>
          </button>
        ))
      ) : (
        <div className="vxi-muted" style={{ padding: '6px 10px' }}>You cannot create interactions here.</div>
      )}
      {showBrowse ? (
        <button
          type="button"
          role="menuitem"
          className="vxi-menu-item"
          data-testid="interaction-menu-browse"
          onClick={() => {
            if (onPicked) onPicked();
            openInteractionBrowser(base);
          }}
        >
          <span className="vxi-menu-icon" aria-hidden="true">🔎</span>
          <span>
            Browse interactions
            <small>Find polls, events, tasks and suggestions here</small>
          </span>
        </button>
      ) : null}
    </div>
  );
}
